var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMtm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-15.194%",
    x2: "111.39%",
    y1: "30.921%",
    y2: "75.205%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#E7F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAE2EB",
    d: "M48.5 27.56l4.94 4.94H50c-.828 0-1.5-.673-1.5-1.5v-3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DFE9",
    d: "M53 59.5H32c-.828 0-1.5-.673-1.5-1.5V28c0-.827.672-1.5 1.5-1.5h15V31c0 1.655 1.346 3 3 3h4.5v24c0 .827-.672 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5FC3D7",
    fillRule: "nonzero",
    d: "M48.219 44.164a.753.753 0 0 0-1.055.117l-2.21 2.764-3.42-4.786C42.97 41.732 44 40.365 44 38.75A3.754 3.754 0 0 0 40.25 35h-3a.75.75 0 0 0-.75.75v10.5a.75.75 0 1 0 1.5 0V42.5h1.864l4.116 5.762-2.816 3.52a.751.751 0 0 0 1.172.937l2.55-3.188 2.254 3.155a.748.748 0 0 0 1.046.174.75.75 0 0 0 .174-1.046l-2.5-3.5 2.476-3.095a.751.751 0 0 0-.117-1.055zM38 36.5h2.25c1.24 0 2.25 1.01 2.25 2.25S41.49 41 40.25 41H38v-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M55.78 32.72l-7.5-7.5a.75.75 0 0 0-.53-.22H32c-1.655 0-3 1.345-3 3v30c0 1.655 1.345 3 3 3h21c1.655 0 3-1.345 3-3V33.25c0-.2-.08-.39-.22-.53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMtm);
export default __webpack_public_path__ + "static/media/ic-mtm.3191ec4f3f3b5a5c731aea7d6d5cd28b.svg";
export { ForwardRef as ReactComponent };